import React from 'react';

const ScenarioDevelopment = () => {
  return (
    <div className="page-content">
      <h3>시나리오 개발 및 선정</h3>
      <div className="content-section">
        <h5>시스템 개요</h5>
        <p>자율주행 차량의 사고 피해(Harm) 발생 과정 및 구조를 Hazardous Behavior, Hazard, Scenario, <br/>
        Hazardous Event, Triggering Condition, Harm이라는 개념간의 관계를 통해 정의하고 표현한다</p>
      </div>
    </div>
  );
};

export default ScenarioDevelopment;